/**
 * Get string from boolean.
 * Example: true -> "Yes"
 * @param value
 */
export default function boolToString(value) {
    return value ? "Yes" : "No";
}
